"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = void 0;
const selectedConfig_1 = require("../../selectedConfig");
const GeoModelCommon_1 = require("./GeoModelCommon");
const typeName = 'Region';
class Region extends GeoModelCommon_1.GeoModelCommon {
    constructor(ob) {
        super({ ...ob, type: ob.type || typeName });
    }
    getUserAttributes() {
        return {
            name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'identification' },
            description: { type: 'String', editable: true, label: 'Description', description: 'description' },
            tz: {
                label: 'Timezone',
                type: 'Enum',
                editable: true,
                enumKv: Object.fromEntries(selectedConfig_1.supportedTZs.map((tz) => [tz, tz])),
            },
        };
    }
}
exports.Region = Region;
